import React, { useEffect, useState } from 'react'
import {
  ActionsRow,
  ApplyButton,
  ClearButton,
  FieldLabel,
  FilterTextInput,
  MenuContainer,
  MenuTitle,
} from './style'
import type { ProductDevelopmentProductFilters } from '../productDevelopmentFilters'

interface ProductDevelopmentFiltersMenuProps {
  position: { top: number; right: number }
  appliedFilters: ProductDevelopmentProductFilters
  onApply: (filters: ProductDevelopmentProductFilters) => void
  onClose: () => void
}

const ProductDevelopmentFiltersMenu: React.FC<ProductDevelopmentFiltersMenuProps> = ({
  position,
  appliedFilters,
  onApply,
  onClose,
}) => {
  const [colecao, setColecao] = useState(appliedFilters.colecao ?? '')
  const [familia, setFamilia] = useState(appliedFilters.familia ?? '')
  const [episodio, setEpisodio] = useState(appliedFilters.episodio ?? '')

  useEffect(() => {
    setColecao(appliedFilters.colecao ?? '')
    setFamilia(appliedFilters.familia ?? '')
    setEpisodio(appliedFilters.episodio ?? '')
  }, [appliedFilters])

  const handleApply = () => {
    onApply({
      colecao: colecao.trim(),
      familia: familia.trim(),
      episodio: episodio.trim(),
    })
    onClose()
  }

  const handleClear = () => {
    setColecao('')
    setFamilia('')
    setEpisodio('')
    onApply({ colecao: '', familia: '', episodio: '' })
    onClose()
  }

  return (
    <MenuContainer style={{ top: `${position.top}px`, right: `${position.right}px` }}>
      <MenuTitle>Filtrar</MenuTitle>

      <FieldLabel htmlFor='pd-filter-colecao'>Coleção</FieldLabel>
      <FilterTextInput
        id='pd-filter-colecao'
        type='text'
        placeholder='Digite a coleção'
        value={colecao}
        onChange={(e) => setColecao(e.target.value)}
      />

      <FieldLabel htmlFor='pd-filter-familia'>Família</FieldLabel>
      <FilterTextInput
        id='pd-filter-familia'
        type='text'
        placeholder='Digite a família'
        value={familia}
        onChange={(e) => setFamilia(e.target.value)}
      />

      <FieldLabel htmlFor='pd-filter-episodio'>Episódio</FieldLabel>
      <FilterTextInput
        id='pd-filter-episodio'
        type='text'
        placeholder='Digite o episódio'
        value={episodio}
        onChange={(e) => setEpisodio(e.target.value)}
      />

      <ActionsRow>
        <ApplyButton type='button' onClick={handleApply}>Aplicar</ApplyButton>
        <ClearButton type='button' onClick={handleClear}>Limpar</ClearButton>
      </ActionsRow>
    </MenuContainer>
  )
}

export default ProductDevelopmentFiltersMenu
